import apiService from './api/api.service';

const profileExtendedService = {
  // Address APIs
  addAddress: async (addressData) => {
    return await apiService.post('/profile-extended/address', addressData);
  },

  updateAddress: async (addressId, addressData) => {
    return await apiService.put(`/profile-extended/address/${addressId}`, addressData);
  },

  deleteAddress: async (addressId) => {
    return await apiService.delete(`/profile-extended/address/${addressId}`);
  },

  getAddresses: async () => {
    return await apiService.get('/profile-extended/addresses');
  },

  getAddressesByUserId: async (userId) => {
    return await apiService.get(`/profile-extended/addresses/${userId}`);
  },

  // Career Focus API
  updateCareerFocus: async (industryId) => {
    return await apiService.put('/profile-extended/career-focus', { industryId });
  },

  // Skills APIs
  addSkill: async (skillData) => {
    return await apiService.post('/profile-extended/skill', skillData);
  },

  updateSkill: async (skillId, skillData) => {
    return await apiService.put(`/profile-extended/skill/${skillId}`, skillData);
  },

  deleteSkill: async (skillId) => {
    return await apiService.delete(`/profile-extended/skill/${skillId}`);
  },

  getSkills: async () => {
    return await apiService.get('/profile-extended/skills');
  },

  getSkillSuggestions: async (search = '', limit = 20) => {
    return await apiService.get('/profile-extended/skills/suggestions', {
      params: { search, limit }
    });
  },

  // Personality Traits APIs
  addPersonalityTrait: async (personalityTraitId) => {
    return await apiService.post('/profile-extended/personality-trait', { personalityTraitId });
  },

  deletePersonalityTrait: async (traitId) => {
    return await apiService.delete(`/profile-extended/personality-trait/${traitId}`);
  },

  getPersonalityTraits: async () => {
    return await apiService.get('/profile-extended/personality-traits');
  },

  getAllPersonalityTraits: async () => {
    return await apiService.get('/profile-extended/personality-traits/all');
  },

  // Experience APIs
  addExperience: async (experienceData) => {
    return await apiService.post('/profile-extended/experience', experienceData);
  },

  updateExperience: async (experienceId, experienceData) => {
    return await apiService.put(`/profile-extended/experience/${experienceId}`, experienceData);
  },

  deleteExperience: async (experienceId) => {
    return await apiService.delete(`/profile-extended/experience/${experienceId}`);
  },

  getExperiences: async () => {
    return await apiService.get('/profile-extended/experiences');
  },

  // Get data by userId (for viewing other users' portfolios)
  getExperiencesByUserId: async (userId) => {
    return await apiService.get(`/profile-extended/experiences/${userId}`);
  },

  getSkillsByUserId: async (userId) => {
    return await apiService.get(`/profile-extended/skills/${userId}`);
  },

  getPersonalityTraitsByUserId: async (userId) => {
    return await apiService.get(`/profile-extended/personality-traits/${userId}`);
  },

  // Complete Profile
  getCompleteProfile: async () => {
    return await apiService.get('/profile-extended/complete');
  }
};

export default profileExtendedService;
